import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AlertTriangle, XCircle } from "lucide-react";

/**
 * Payment-cancelled feedback banner — Stripe brought the user back via
 * cancel_url. Reassures them no charge happened + offers retry context.
 */
export const PaymentCancelledBanner = ({ visible, onDismiss, t }) => (
  <AnimatePresence>
    {visible && (
      <motion.div
        key="payment-cancelled-banner"
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -60, opacity: 0 }}
        transition={{ type: "spring", damping: 22, stiffness: 240 }}
        role="status"
        aria-live="polite"
        data-testid="payment-cancelled-banner"
        className="fixed left-1/2 -translate-x-1/2 z-[400]"
        style={{
          top: 16,
          maxWidth: 420,
          width: "calc(100% - 24px)",
          padding: "12px 14px",
          borderRadius: 14,
          background: "linear-gradient(135deg,#FFFBEB 0%,#FEF3C7 100%)",
          border: "1.5px solid #FDE68A",
          boxShadow: "0 8px 22px rgba(120,53,15,0.15)",
        }}
      >
        <div className="flex items-start gap-2.5">
          <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: "#B45309" }} strokeWidth={2.4} />
          <div className="flex-1">
            <p className="font-black" style={{ fontSize: 13, color: "#78350F", lineHeight: 1.25 }}>
              {t("paymentCancelledTitle") || "Payment cancelled"}
            </p>
            <p className="mt-0.5 leading-[1.4]" style={{ fontSize: 12, color: "rgba(120,53,15,0.92)" }}>
              {t("paymentCancelledBody") || "No charge has been made. You can try again whenever you're ready."}
            </p>
          </div>
          <button
            type="button"
            onClick={onDismiss}
            aria-label={t("close") || "Close"}
            data-testid="payment-cancelled-dismiss"
            style={{
              width: 26, height: 26, borderRadius: 8,
              background: "rgba(120,53,15,0.08)", color: "#78350F",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <XCircle className="w-4 h-4" strokeWidth={2.4} />
          </button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
